import { render, staticRenderFns } from "./mobilePriceList.vue?vue&type=template&id=3cc52c5f&scoped=true&"
import script from "./mobilePriceList.vue?vue&type=script&lang=js&"
export * from "./mobilePriceList.vue?vue&type=script&lang=js&"
import style0 from "./mobilePriceList.vue?vue&type=style&index=0&id=3cc52c5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc52c5f",
  null
  
)

export default component.exports